export const IMPERSONATION_SESSION_STORAGE_KEY = 'sessionImpersonation';
export const IMPERSONATION_SESSION_ENDED = 'sessionImpersonationEnded';
